import { render, staticRenderFns } from "./Regbites.vue?vue&type=template&id=ea709f2e&"
import script from "./Regbites.vue?vue&type=script&lang=js&"
export * from "./Regbites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports